import BaseCrumb from './BaseCrumb';
import BreadcrumbItem from './BreadcrumbItem';

type Props = {
  breadcrumbs?: Breadcrumb[];
  showLogo?: boolean;
  size?: 'large' | 'default';
};

const Breadcrumbs: FC<Props> = ({ breadcrumbs, showLogo, size }) => {
  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <div className="inline-container">
      <BaseCrumb showLogo={showLogo} size={size} />
      {breadcrumbs.map((crumb, index) => (
        <BreadcrumbItem
          key={`${crumb.to}${crumb.translateId}`}
          breadcrumb={crumb}
          size={size}
          isLast={index === breadcrumbs.length - 1}
        />
      ))}
    </div>
  );
};

export default Breadcrumbs;
